@if (showBanner) {
  <div class="cookie-banner">
    <p class="cookie-banner__message">{{ 'cookieBanner.message' | translate }}</p>
    <div class="cookie-banner__actions">
      <button type="button" class="cookie-banner__btn cookie-banner__btn--reject" (click)="reject()">
        {{ 'cookieBanner.reject' | translate }}
      </button>
      <button type="button" class="cookie-banner__btn cookie-banner__btn--accept" (click)="accept()">
        {{ 'cookieBanner.accept' | translate }}
      </button>
    </div>
  </div>
}
